/**
 * Orca Project Detail route — eagerly registers the route + per-id
 * `beforeLoad` SSR loader but defers component + atom + Mermaid imports
 * via `.lazy.tsx`. This keeps the orca admin chunk (including Mermaid)
 * out of the bundle for users on every other route.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";
import { orcaProjectDetailBeforeLoad } from "~/lib/orca-ssr.ts";
import { orcaloopsStylesheetLinks } from "~/lib/orcaloops-head.ts";

/**
 * The orcaloops seam's stylesheet as a render-blocking head `<link>` — the v5
 * frame (OL-402) must paint styled on SSR, never after the lazy chunk loads.
 *
 * @since 1.0.0
 */
export const projectDetailHead = () => ({ links: orcaloopsStylesheetLinks });

export const Route = createFileRoute("/orca/projects/$projectId")({
  beforeLoad: orcaProjectDetailBeforeLoad,
  head: projectDetailHead,
});
